import { api, EMAIL_SUCCESS_MESSAGE } from '../..';

export const emailLogin = (email: string, loginType: string): Promise<string | void> =>
	api.post(`/login?loginType=${loginType}`, { email: email }).then(() => {
		return EMAIL_SUCCESS_MESSAGE;
	});
